import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_user/my-coaching/")({
  loader: ({ context }) => {
    // Every coach lands on Welcome, including one under review. A revoked
    // coach lands on the dashboard, which shows her state.
    throw redirect({
      to: context.isRevoked
        ? "/my-coaching/clients/dashboard"
        : "/my-coaching/welcome",
    });
  },
});
